import React from 'react';
import { SurveyPage } from './pages/SurveyPage';
import { RedTrack } from './components/RedTrack';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  return <>
      <RedTrack data-id="element-0" />
      <FacebookPixel data-id="element-1" />
      <SurveyPage data-id="element-2" />
    </>;
}